export default __webpack_public_path__ + "static/media/liveFeedMessage.f4070b68.png";